import React from 'react';
import { useGetScheduleRangesQuery } from 'store/scheduleRanges/scheduleRanges';
import { useGetLoggedEmployeeQuery } from 'store/employee/employees';
import { LoggedEmployee } from 'store/employee/interfaces';
import EmployeeWorkingHours from 'pages/EmployeeWorkingHours/EmployeeWorkingHours';
import ScheduleTracking from 'pages/ScheduleTracking/ScheduleTracking';
import ContentSuspense from 'common/ContentSuspense/ContentSuspense';
import ScheduleCalendarProvider from 'components/ScheduleCalendar/context/ScheduleCalendarProvider';

export default function ProjectTracking() {
  const { data: currentEmployee = {} as LoggedEmployee } =
    useGetLoggedEmployeeQuery();

  const {
    data: scheduleRangesData = { 'hydra:member': [] },
    isLoading: scheduleRangesDataLoading,
    isError: scheduleRangesDataError,
  } = useGetScheduleRangesQuery(
    { schedule: currentEmployee?.activeSchedule },
    {
      skip: !currentEmployee?.activeSchedule,
    },
  );

  const scheduleRanges = scheduleRangesData['hydra:member'];

  return (
    <ContentSuspense
      isLoading={scheduleRangesDataLoading}
      isError={scheduleRangesDataError}
    >
      {scheduleRanges.length ? (
        <ScheduleCalendarProvider scheduleRanges={scheduleRanges}>
          <ScheduleTracking />
        </ScheduleCalendarProvider>
      ) : (
        <EmployeeWorkingHours />
      )}
    </ContentSuspense>
  );
}
